import { getRequest, postRequest, putRequest } from './request'
import { FeedbackType } from '@shared/constants/feedback'
import { NotificationStatus } from '@shared/constants/notification'

import { DOMAIN } from './constant'

// ===============feedback=================

export const submitFeedback = (data: {
  feedbackType: FeedbackType
  phone?: string
  description: string
  screenshots?: string[]
  status?: number
}) => {
  return postRequest(`${DOMAIN}/api/feedback`, data)
}

// ===============notification=================
export const getNotificationList = (params?: {
  pageSize?: number
  pageNum?: number
}) => {
  return getRequest(`${DOMAIN}/api/notifications`, params)
}

export const readNotification = (id: string) => {
  return putRequest(`${DOMAIN}/api/notifications/${id}`, { status: NotificationStatus.READ })
}

export const readAllNotification = () => {
  return putRequest(`${DOMAIN}/api/notifications/read`, {})
}

export const getUnreadNotificationCount = () => {
  return getRequest(`${DOMAIN}/api/notifications/unread`)
}